import httpRequest from 'services/httpRequest';
import {
  CONNECT_COMPETENCY_WEBSOCKET,
  DISCONNECT_COMPETENCY_WEBSOCKET,
  setCompetencyWebSocketStatus,
  updateCompetencyAssessmentFromSocket,
} from '../actions/competency.action';
import { fetchCompetencyAssessment } from '../actions/competency.thunk';

let ws: WebSocket | null = null;
let reconnectTimeout: NodeJS.Timeout | null = null;
let retryCount = 0;
const MAX_RETRIES = 10;
const RECONNECT_INTERVAL = 2000;
let currentUserId: string | null = null;

const competencyWebSocketMiddleware = (store: any) => (next: any) => (action: any) => {
  switch (action.type) {
    case CONNECT_COMPETENCY_WEBSOCKET: {
      const userId = action.payload;
      
      // Prevent duplicate connections
      if (ws && ws.readyState === WebSocket.OPEN && currentUserId === userId) {
        return next(action);
      }

      // Close existing connection if userId changed
      if (ws && currentUserId !== userId) {
        ws.close();
        ws = null;
      }

      currentUserId = userId;

      const connectWebSocket = () => {
        if (retryCount > MAX_RETRIES) {
          console.warn('⚠️ Max reconnect attempts reached for competency WebSocket');
          return;
        }

        const url = `${httpRequest.aetAssessmentsWebsocketUrl}?user_id=${userId}`;
        ws = new WebSocket(url);

        ws.onopen = () => {
          console.log('✅ Competency WebSocket connected');
          retryCount = 0;
          store.dispatch(setCompetencyWebSocketStatus(true));
        };

        ws.onmessage = (event) => {
          try {
            const payload = JSON.parse(event.data);
            if (typeof payload === 'object') {
              store.dispatch(updateCompetencyAssessmentFromSocket(payload));
              // Refetch data when socket message received (force = true)
              store.dispatch(fetchCompetencyAssessment(userId, true));
            }
          } catch (err) {
            console.error('Invalid WebSocket message:', err);
          }
        };

        ws.onclose = () => {
          console.log('❌ Competency WebSocket disconnected');
          store.dispatch(setCompetencyWebSocketStatus(false));
          
          // Schedule reconnect if not manually disconnected
          if (currentUserId === userId) {
            retryCount += 1;
            if (retryCount <= MAX_RETRIES) {
              reconnectTimeout = setTimeout(() => {
                if (currentUserId === userId) {
                  connectWebSocket();
                }
              }, RECONNECT_INTERVAL);
            }
          }
        };

        ws.onerror = (err) => {
          console.error('⚠️ Competency WebSocket error:', err);
          ws?.close();
        };
      };

      connectWebSocket();
      break;
    }

    case DISCONNECT_COMPETENCY_WEBSOCKET: {
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
        reconnectTimeout = null;
      }
      retryCount = 0;
      currentUserId = null;
      
      if (ws) {
        ws.close();
        ws = null;
      }
      
      store.dispatch(setCompetencyWebSocketStatus(false));
      console.log('🛑 Competency WebSocket manually disconnected');
      break;
    }

    default:
      break;
  }

  return next(action);
};

export default competencyWebSocketMiddleware;
